import TemplateView from "../../../TemplateView";

export default class TaskCardName extends TemplateView {
    constructor() {
        super()

        this.state = {
            html: ''
        }

        this.onStatePropertyChanged('html', html => this.$el.html(html))
    }

    templateHtml() {
        return "<div class='name gradientEllipsis'></div>"
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/kanban/components/TaskCardName.js